module.exports = __webpack_public_path__ + "static/fcic-fr-logo-9073b980d7d6883340d138ed8cc82962.png";